import logo from '../../icons/logo-RGB-16.png'
import { Container, Text, Title } from './style'
const NotFound = () => {
  return (
    <Container>
      <img src={logo} alt="logo" />
      <Title>404</Title>
      <Text>Página não encontrada</Text>
    </Container>
  )
}
export default NotFound
